export default {
  submitText: '提交',
  emptyBtn: false,
  labelWidth: 150,
  group: [
    {
      label: '任务信息',
      arrow: false,
      column: [
        {
          label: '任务类型',
          prop: 'type',
          type: 'select',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=type',
          props: { label: 'dictValue', value: 'dictKey' },
          disabled: true,
        },
        {
          label: '巡检日期',
          prop: 'taskTime',
          type: 'date',
          format: 'yyyy-MM-dd',
          valueFormat: 'yyyy-MM-dd',
          pickerOptions: {
            disabledDate(time) {
              return time.getTime() <= new Date(new Date().toLocaleDateString()).getTime() - 1;
            },
          },
          rules: [
            {
              required: true,
              message: '请输入巡检日期',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '任务名称',
          prop: 'planName',
          maxlength: 30,
          showWordLimit: true,
          rules: [
            {
              required: true,
              message: '请输入任务名称',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '允许超期',
          prop: 'staleDatedStatus',
          type: 'radio',
          dataType: 'number',
          dicUrl: 'api/blade-system/dict/dictionary?code=stale_dated_status',
          props: { label: 'dictValue', value: 'dictKey' },
          rules: [
            {
              required: true,
              message: '请选择是否允许超期',
              trigger: 'blur',
            },
          ],
          value: 1,
        },
        {
          label: '超期时间(分钟)',
          prop: 'beyondTheTime',
          display: false,
        },
        {
          label: '时间段',
          span: 24,
          row: true,
          prop: 'time',
          formslot: true,
          typeslot: true,
          labelslot: true,
        },
      ],
    },
    {
      label: '巡检信息',
      arrow: false,
      column: [
        {
          label: '所属小区',
          prop: 'areaId',
          formslot: true,
        },
        {
          label: '班组名称',
          prop: 'groupId',
          formslot: true,
          rules: [
            {
              required: true,
              message: '选择班组名称',
              trigger: 'blur',
            },
          ],
        },
        {
          label: '巡检点名称',
          prop: 'nodeId',
          formslot: true,
          rules: [
            {
              required: true,
              message: '请选择巡检点名称',
              trigger: 'blur',
            },
          ],
        },
        {
          prop: 'crud1',
          label: '巡检项',
          formslot: true,
          labelslot: true,
          span: 24,
        },
      ],
    },
  ],
};
